<template>
  <div id="app">
    <vue-confirm-dialog></vue-confirm-dialog>
    <nav class="navbar navbar-expand navbar-dark bg-dark">
      <a href class="navbar-brand" @click.prevent>Tippchen<p class="version-style">v1.4.1</p></a>
      <div class="navbar-nav mr-auto">

        <li class="nav-item">
          <router-link to="/home" class="nav-link">
            <div v-responsive.sm.xs>
              <font-awesome-icon icon="home"/>
            </div>
            <div v-responsive.md.lg.xl>
              <font-awesome-icon icon="home"/>
              Start
            </div>
          </router-link>
        </li>

        <!-- User View -->
        <li class="nav-item">
          <router-link v-if="currentUser" to="/user" class="nav-link">
            <div v-responsive.md.lg.xl>
              <font-awesome-icon icon="dice"/>
              Tippen
            </div>
            <div v-responsive.sm.xs>
              <font-awesome-icon icon="dice"/>
            </div>
          </router-link>
        </li>

        <li class="nav-item">
          <router-link v-if="currentUser" to="/ranking" class="nav-link">
            <div v-responsive.md.lg.xl>
              <font-awesome-icon icon="trophy"/>
              Übersicht
            </div>
            <div v-responsive.sm.xs>
              <font-awesome-icon icon="trophy"/>
            </div>

          </router-link>
        </li>

        <!-- Manager View -->
        <li v-if="showModeratorBoard" class="nav-item">
          <router-link to="/mod" class="nav-link">Manage</router-link>
        </li>

        <!-- Administration View -->
        <li v-if="showAdminBoard" class="nav-item">
          <router-link to="/admin" class="nav-link">Admin</router-link>
        </li>

      </div>

      <!-- Not logged in View -->
      <div v-if="!currentUser" class="navbar-nav ml-auto">

        <!--
                  <li class="nav-item">
                    <router-link to="/register" class="nav-link">
                      <div v-responsive.md.lg.xl><font-awesome-icon icon="user-plus" />Registrieren</div>
                      <div v-responsive.sm.xs><font-awesome-icon icon="user-plus" /></div>
                    </router-link>
                  </li>
        -->

        <li class="nav-item">
          <router-link to="/login" class="nav-link">
            <div v-responsive.md.lg.xl>
              <font-awesome-icon icon="sign-in-alt"/>
              Einloggen
            </div>
            <div v-responsive.sm.xs>
              <font-awesome-icon icon="sign-in-alt"/>
            </div>
          </router-link>
        </li>

      </div>

      <div v-if="currentUser" class="navbar-nav ml-auto">

        <li class="nav-item">

          <router-link v-responsive.sm.xs to="/profile" class="nav-link">
            <font-awesome-icon icon="user"/>
          </router-link>

          <router-link v-responsive.md.lg.xl to="/profile" class="nav-link">
            <font-awesome-icon icon="user"/>
            {{ currentUser.username }}
          </router-link>
        </li>

        <li class="nav-item">
          <a v-responsive.sm.xs class="nav-link" href @click.prevent="logOut">
            <font-awesome-icon icon="sign-out-alt"/>
          </a>
          <a v-responsive.md.lg.xl class="nav-link" href @click.prevent="logOut">
            <font-awesome-icon icon="sign-out-alt"/>
            Abmelden
          </a>
        </li>

      </div>
    </nav>

    <div class="container">
      <router-view/>
    </div>
  </div>
</template>

<script>

export default {
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
    showAdminBoard() {
      if (this.currentUser && this.currentUser.roles) {
        return this.currentUser.roles.includes('ROLE_ADMIN');
      }
      return false;
    },
    showModeratorBoard() {
      if (this.currentUser && this.currentUser.roles) {
        return this.currentUser.roles.includes('ROLE_MODERATOR');
      }

      return false;
    }
  },
  methods: {
    logOut() {
      this.$store.dispatch('auth/logout');
      this.$router.push('/login');
    }
  },
  mounted() {
    console.log("App --> mounted() --> getCurrentMatchDay");
    this.$store.dispatch('sys/getCurrentMatchDay')
        .then(() => {
          console.log("App --> mounted() --> checkMode");
          return this.$store.dispatch('sys/checkMode');
        })
        .then(() => {
          console.log("App --> mounted() --> getCurrentSeasonYear");
          return this.$store.dispatch('sys/getCurrentSeasonYear');
        })
        .then(() => {
          console.log("App --> mounted() --> getSubscription");
          this.$store.dispatch('sys/getSubscription');
        })
        .catch(err => {
          console.log("Error: " + err.message);
        })
  }
};
</script>

<style>

.version-style {
  font-size: 0.4em;
}
</style>
